import "./dashboard.scss";

import { useEffect, useState } from "react";
import { useAuth } from "../../authentication/authHelpers";
import LoaderComponent from "../commonComponents/LoadableComp/LoadableComp";
import AdminDashboard from "./AdminDashboard/AdminDashboard";
import UserDashboard from "./UserDashboard";
import ModalAnnounce from "../Announcement/ModalAnnounce/ModalAnnounce";

function DashboardBase() {
  const auth = useAuth();
  const [loading, setLoading] = useState(true);
  const [viewType, setViewType] = useState(null);

  const onInitAdmin = async () => {
    window.OneSignal = window.OneSignal || [];
    const OneSignal = window.OneSignal;
    // OneSignal.setDefaultTitle("My Title");
    await OneSignal.push(() => {
      OneSignal.init({
        appId: "cd2085f7-5cf7-4a64-be0a-b53f049a34fc", //STEP 9
      });
      OneSignal.sendTags({
        identityId: `${auth?.userAccess[0]?.identityId}`,
        userRole: "Admin",
      });
    });
  };

  const onInitAdminDev = async () => {
    window.OneSignal = window.OneSignal || [];
    const OneSignal = window.OneSignal;
    // OneSignal.setDefaultTitle("My Title");
    await OneSignal.push(() => {
      OneSignal.init({
        appId: "9e32441c-55a6-4dcf-b0dd-d3ecca7aa921", //STEP 9
      });
      OneSignal.sendTags({
        identityId: `${auth?.userAccess[0]?.identityId}`,
        userRole: "Admin",
      });
    });
  };

  const onInitEmpl = async () => {
    window.OneSignal = window.OneSignal || [];
    const OneSignal = window.OneSignal;
    // OneSignal.setDefaultTitle("My Title");
    await OneSignal.push(() => {
      OneSignal.init({
        appId: "cd2085f7-5cf7-4a64-be0a-b53f049a34fc", //STEP 9
      });
      OneSignal.sendTags({
        identityId: `${auth?.userAccess[0]?.identityId}`,
        userRole: "Employee",
      });
    });
  };

  const onInitEmplDev = async () => {
    window.OneSignal = window.OneSignal || [];
    const OneSignal = window.OneSignal;
    // OneSignal.setDefaultTitle("My Title");
    await OneSignal.push(() => {
      OneSignal.init({
        appId: "9e32441c-55a6-4dcf-b0dd-d3ecca7aa921", //STEP 9
      });
      OneSignal.sendTags({
        identityId: `${auth?.userAccess[0]?.identityId}`,
        userRole: "Employee",
      });
    });
  };

  useEffect(() => {
    if (auth.userAccess.length > 0) {
      if (
        auth.userAccess[0].userRole === "Admin" ||
        auth.userAccess[0].userRole === "Super Admin"
      ) {
        setViewType("Admin");
        setLoading(false);

        process.env.NODE_ENV === "production"
          ? onInitAdmin()
          : onInitAdminDev();
        // onInitAdminDev();
      } else {
        setViewType("User");
        setLoading(false);

        // onInitEmpl();
        process.env.NODE_ENV === "production" ? onInitEmpl() : onInitEmplDev();
      }
    }
  }, [auth]);
  return (
    <LoaderComponent loading={loading}>
      {/* <Button onClick={() => onSubscribe()}>test</Button> */}
      {/* <button onClick={onText}> Test</button> */}
      {viewType === "Admin" ? (
        <AdminDashboard />
      ) : viewType === "User" ? (
        <UserDashboard role={auth?.userAccess[0]?.userRole || "User"} />
      ) : (
        <></>
      )}
      <ModalAnnounce open={true} />
    </LoaderComponent>
  );
}
export default DashboardBase;
